import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from 'app/auth/auth.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { BehaviorSubject } from 'rxjs';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { DatePipe } from '@angular/common';
import { EMRService } from 'app/EMR/EMR.service';



@Injectable({
    providedIn: 'root'
  })
  
  export class IPDService {
     selectedServiceRow: any =[];
     selectePatientData: any={};
     public baseUrl:string;
     public newbaseUrl:string;  
     public content = new BehaviorSubject<object>({});
     public share = this.content.asObservable();
  sschecklistMaster: any;
  
     constructor(public datePipe:DatePipe, public http: HttpClient, public authservice: AuthService, public opdvisitService: OpdVisitService,public dashboardService:DashboardService,public emrservice:EMRService)
      {
            this.baseUrl =this.authservice.baseUrl;
            this.newbaseUrl =this.authservice.newbaseUrl;
       }

       

     //getwardlist
     getWardList(){
       return this.http.get<any>(this.newbaseUrl+"IPD/GetWardName")
     }


     getOTContent(){
      // return this.http.get<any>(this.newbaseUrl+"Common/GetDocumentMaster/OTConcent");
       return this.http.get<any>(this.newbaseUrl+"Common/GetDocumentMaster/OTConsent");
     }

     GetNotYetReported(branchid,date){
      return this.http.get<any>(this.newbaseUrl+"IPDWorkup/GetYetToReportByBranchIDBySurgeryDate/"+branchid +'/'+ date);
     }
     GetpackageList(type,id,date){
      return this.http.get<any>(this.newbaseUrl+"IPD/GetPackageDetail/"+type +'/'+id +'/'+ date +'/'+this.authservice.Loggeduser.specialityId);
     }

   
     getLastAddmittedpateintdetails(sdate: string, edate: string,branchid:number) {
      return this.http.get<any>(this.newbaseUrl + "IPD/GetIpdRegListFromDateToDate/" +branchid+ '/'+
        sdate + '/' + edate )
    }
 
    insertIpdRegistration(data:any){
      return this.http.post<any>(this.newbaseUrl + "IPD/InsertIpdRegistration/" , data)
    }

    GetpackagebyIpdId(id){
      return this.http.get<any>(this.newbaseUrl+"ipd/GetPackageDetailByIPDId/"+id);
     }

     
    GetUpgradedpackagebyIpdId(id){
      return this.http.get<any>(this.newbaseUrl+"ipd/GetUpgradePackageDetailByIPDId/"+id);
     }

     getIPDtype(){
       return this.http.get<any>(this.newbaseUrl+"Common/GetPopUpHelpGeneral/IPDCategory")
     }


     deletePackage(id){
      return this.http.get<any>(this.newbaseUrl+"IPD/DeletePackageDetailByTranId/" + id)
    }

    getIpdDetailbyId(id){
      return this.http.get<any>(this.newbaseUrl+"IPD/GetIpdRegListByRegId/" + id +'/'+this.authservice.Loggeduser.specialityId)
    }
    GetIpdRegByIPDId(ipd){
      return this.http.get<any>(this.newbaseUrl+"IPD/GetIpdRegByIPDId/" + ipd);
    }

    getIpdbookingData(id){
      return this.http.get<any>(this.newbaseUrl+"IPD/GetIpdBookedPackageListByRegId/" + id)
    }
    getbillSummery(id){
      return this.http.get<any>(this.newbaseUrl+"VisitMaster/GetBills/" + id  + '/' + this.authservice.Loggeduser.specialityId)
    }
    GetIpdRegDetailbed(ipdid){
      return this.http.get<any>(this.newbaseUrl+"ipd/GetIpdRegDetailByIPDId/" + ipdid)
    }
    getIpdbookingPackage(typeId,id){
      return this.http.get<any>(this.newbaseUrl+"IPD/GetIpdBookedPackageDetailByRateTypeIDByCounselorId/" +typeId+'/' + id)
    }

    getIpdbookingUpgradePackage(id){
      return this.http.get<any>(this.newbaseUrl+"IPD/GetIpdBookedUpgradePackageDetailByCounselorId/" + id)
    }
    GetCounselorAdditionalService(CounselorId){
      return this.http.get<any>(this.newbaseUrl+"Councelor/GetCounselorAdditionalServiceDetailByCounselorId/" + CounselorId)
    }
   
    deletePatientDocument(IpdId,docname,branchid,fname){
   
      return this.http.get<any>(this.newbaseUrl+"Document/DeleteFile/"+IpdId+"/"+docname+"/" +branchid +"/"+fname)
    }
    deleteServerPatientDocument(payload){
   
      return this.http.post<any>(this.newbaseUrl+"Document/DeleteFile",payload);
    }
    deleteAzurePatientDocument(payload){
   
      return this.http.post<any>(this.newbaseUrl+"DocumentUpload/DeleteFile",payload);
    }
   // ipd Dashboard services

     getIpdLocation(id){
      return this.http.get<any>(this.newbaseUrl+"Common/GetIpdLocationMaster/" + id)
    }
    //get op api
    GetOTData(branchid){
      return this.http.get<any>(this.newbaseUrl+"Common/GetOtGroupByBranchID/" +branchid)
    }

    GetALlIpdData(branchId,admintid,afromdate,atodate,dfromdate,dtodate,roomcatID,consultid,patientid,IPDID,operationtypeid,threateid,patientName,otgroup,fkcategoryid){
      return this.http.get<any>(this.newbaseUrl+"IPD/GetIPDDashboardByBranchIdByAdmittedByIPDFromDateByIPDToDateByIPDDischargeFromDateByIPDDischargeToDateByRoomCategoryIdByConsultantIdByPatientIDByIPDIDByOperationTypeIdByTheatreIdByPatientNameByOTGroup/"+branchId+"/"+admintid+"/" +afromdate +"/"+atodate +"/"+dfromdate+"/"+dtodate+"/" +roomcatID +"/"+consultid +"/"+patientid+"/"+IPDID+"/" +operationtypeid +"/"+threateid +"/"+patientName+"/" +otgroup+"/"+fkcategoryid)
    }
    GetOPType(){
      return this.http.get<any>(this.newbaseUrl+"Common/GetOperationTypeMasterByOperationType/" + 0);
    }
      //get Ot Theatre
      GetOtTheatre(branchid){
        return this.http.get<any>(this.newbaseUrl+"Common/GetOtTheatreMasterByBranchID/" +branchid)
      }

      GetPostponed(){
        return this.http.get<any>(this.newbaseUrl+"Common/GetPostponedStatus");
      }
      MoveOtherLocation(ipdid,locationId){
        return this.http.get<any>(this.newbaseUrl+"IPD/UpdateIPDDashboardLocationIdByIPDID/"+ipdid +"/"+ locationId);
      }

      NotyetReported(branchid){
        
        return this.http.get<any>(this.newbaseUrl+"IPD/GetIPDDashboardOpdCounselorExaminationYetToReportCountCurrentDateByBranchId/" +branchid)
      }


  getAnesthesiaMaster() {
    return this.http.get<any>(this.newbaseUrl + "IPDWorkup/GetAnesthesiaQuestions");
    //return this.http.get<any>(this.newbaseUrl + "IPDWorkupMaster/GetAnesthesiaQuestions");
  }
  addAnesthesiaMaster(data) {
    return this.http.post<any>(this.newbaseUrl + "IPDWorkupMaster/InsertAnesthesiaQuestions", data);
  }
  getByIpdId(IPDid,consid) {
    return this.http.get<any>(this.newbaseUrl + "IPDWorkup/GetAnesthesiaQuestionDetailByIPDIDOrByConsID/" + IPDid + "/" + consid);
  }
  getPainsacale(IPDid){
    return this.http.get<any>(this.newbaseUrl + "IPDWorkup/GetIpdPainScaleDetailByIPDID/" + IPDid);
  }
  insertPainScale(data){ 
    return this.http.post<any>(this.newbaseUrl + "IPDWorkup/InsertIpdPainScaleDetail", data);
  }
  addAnesthesiaIpd(data) {
    return this.http.post<any>(this.newbaseUrl + "IPDWorkup/InsertAnesthesiaQuestionsDetail", data);
  }
  getPreOpListMaster() {
    return this.http.get<any>(this.newbaseUrl + "IPDWorkUp/GetPreOperativeCheckListName");
   // return this.http.get<any>(this.newbaseUrl + "IPDWorkUpMaster/GetPreOperativeCheckListName");
  }
  getPreOplistByIpdname(name) {
    return this.http.get<any>(this.newbaseUrl + "IPDWorkUp/GetPreOperativeCheckListByCheckListName/" + name );
    //return this.http.get<any>(this.newbaseUrl + "IPDWorkUpMaster/GetPreOperativeCheckListByCheckListName/" + name );
  }
  savePreOpListIpd(data) {
    return this.http.post<any>(this.newbaseUrl + "IPDWorkup/InsertPreOpCheckList", data);
  }
  updatePreOpListIpd(data) {
    return this.http.post<any>(this.newbaseUrl + "IPDWorkup/InsertPreOpCheckList", data);
  }
  getPreOpListByIpdId(IPDid) {
    return this.http.get<any>(this.newbaseUrl + "IPDWorkUp/GetPreOpCheckListByIPDId/" + IPDid );
  }
  getGAListByIpdId(IPDid) {
    return this.http.get<any>(this.newbaseUrl + "IPDWorkUp/GetGACheckListByIPDId/" + IPDid );
  }
  getGAListMaster() {
    return this.http.get<any>(this.newbaseUrl + "IPDWorkUp/Getgachecklistmaster");
   // return this.http.get<any>(this.newbaseUrl + "IPDWorkUpMaster/Getgachecklistmaster");
  }
  saveGACheckList(data) {
    return this.http.post<any>(this.newbaseUrl + "IPDWorkup/InsertGACheckList", data);
  }
  updateGACheckList(data) {
    return this.http.post<any>(this.newbaseUrl + "IPDWorkup/InsertGACheckList", data);
  }

  // Patient Bed transfer
  getRoomCategoryMaster(moduletypeid:any) {
    return this.http.get<any>(this.newbaseUrl + "ipd/GetRoomcategory/"+moduletypeid);
  }
  
  getRoomCategoryCount() {
    return this.http.get<any>(this.newbaseUrl + "ipd/GetRoomcategoryCount");
  }

  GetIPDDashboardHeadName(){
    return this.http.get<any>(this.newbaseUrl + "IPD/GetIPDDashboardHeadName");
  }

  GetIPDTrackingDetailByIPDId(IPDid){
   return this.http.get<any>(this.newbaseUrl + "IPD/GetIPDTrackingDetailByIPDId/" + IPDid);
  }

  InsertIPDTrackingDetail(data) {
    return this.http.post<any>(this.newbaseUrl + "IPD/InsertIPDTrackingDetail", data);
  }
  getAdmittedPateints() {
    return this.http.get<any>(this.newbaseUrl + "IPD/GetBedMaster/1");
  }

  ipdRegDetails(data) {
    return this.http.post<any>(this.newbaseUrl + "ipd/InsertIpdregdetail", data); 
  }
  GetExamGResultByregid(regid: any) {
    return this.http.get(this.newbaseUrl + "DoctorWorkUp/GetOPDDrExaminationByRegId/" + regid +'/'+0+'/'+0)
  }
  getpackageById(counselorId) {
    return this.http.get<any>(this.newbaseUrl + "Councelor/GetOpdCounselorPackageDetailByCounselorId/" + counselorId);
  }
  updateDischarge(data) {
    return this.http.post<any>(this.newbaseUrl + "IPD/UpdateIpdRegMaster", data);
  }
  getDischarge(IPDid){   
    return this.http.get<any>(this.newbaseUrl + "IPDWorkup/GetDischargeByIPDId/" + IPDid );
  }
 getOTconstent(Fk_ConsId, DocumentType){   
    return this.http.get<any>(this.newbaseUrl + "IPDWorkup/GetOTConsentByConsIDByDocumentType/" + Fk_ConsId + "/" + DocumentType);
  }
  getInstructiontype(TranIDByType,type){
    return this.http.get<any>(this.newbaseUrl + "IPDWorkup/GetDischargeInstructionsByTranIDByType/" + TranIDByType + "/" + type);
   // return this.http.get<any>(this.newbaseUrl + "IPDWorkupMaster/GetDischargeInstructionsByTranIDByType/" + TranIDByType + "/" + type);
  }
  insertDischargeInstructions(data) {
    return this.http.post<any>(this.newbaseUrl + "IPDWorkupMaster/InsertDischargeInstructions", data);
  }
  get_pasthistory(regid) {
    return this.http.get<any>(this.newbaseUrl + "HistoryDisease/" +
    regid +'/'+ 0);
  }
  get_allergies(regid) {
    return this.http.get<any>(this.newbaseUrl + "HistoryDrugAllergy/" +
    regid)
  }
  get_otherinfo(regid) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "HistoryGeneral/" +
    regid)
  }
  getDischagreSummery(ipdid){
    return this.http.get<any>(this.newbaseUrl + "IPDWorkup/GetIpdDischargeRegisterByIPDID/" +
    ipdid)
  }
  
  insertIpdDischargeRegister(data) {
    return this.http.post<any>(this.newbaseUrl + "IPDWorkup/InsertIpdDischargeRegister", data);
  }
  insertDischargeInstruction(data) {
    return this.http.post<any>(this.newbaseUrl + "IPDWorkup/InsertDischargeInstructionDetail", data);
  }
  
  getOtRecordSurgeryByIPDId(ipdid) {
    return this.http.get<any>(this.newbaseUrl + "IPDWorkup/GetOtRecordSurgeryByIPDId/"+
    ipdid);
  }
  getOtRecordComplaintRegid(regid) {
    return this.http.get<any>(this.newbaseUrl + "OpdComplaintsDetail/GetComplaints/"+0+'/'+
    regid);
  }
  instructionDetailByIPDID(ipdid){
    return this.http.get<any>(this.newbaseUrl + "IPDWorkup/GetDischargeInstructionDetailByIPDID/" +
    ipdid)
  }
  getDischargeExamination(ipdid){
    return this.http.get<any>(this.newbaseUrl + "IPDWorkup/GetDischargeExaminationDetailByIPDID/" +
    ipdid)
  }
  getDischargeMedicine(ipdid){
    return this.http.get<any>(this.newbaseUrl + "IPDWorkup/GetDischargePrescriptionDetailByIPDID/" +
    ipdid)
  }
  insertDIschargeExamination(data){
    return this.http.post<any>(this.newbaseUrl +"IPDWorkup/InsertDischargeExaminationDetail",data);
  }
  insertDischargePrescription(data){
    return this.http.post<any>(this.newbaseUrl +"IPDWorkup/InsertDischargePrescriptionDetail",data);
  }
  getipdExmaRegid(regidi){ 
   return this.http.get(this.newbaseUrl + "DoctorWorkUp/GetFindingByRegId/" + regidi + '/' + 0 + '/' + 0);
   
  }
  getmediciedataIpd(ipdid){ 
    return this.http.get(this.newbaseUrl + "IPDWorkup/GetIpdVisitPrescriptionDetailByIPDID/" + ipdid );
  }
  getExaminationList(examvisitid,ipdid){
    return this.http.get<any>(this.newbaseUrl +"IPDWorkup/GetIpdExaminationMasterByIPDVisitIdByIPDID/"+examvisitid +"/"+ipdid);
  }
  getIpdPresception(examvisitid,ipdid){
    return this.http.get<any>(this.newbaseUrl +"IPDWorkup/GetIpdVisitPrescriptionDetailByIPDVisitIdByIPDID/"+examvisitid +"/"+ipdid)
  }
  getIpdvisitInvest(examvisitid,ipdid){
    return this.http.get<any>(this.newbaseUrl +"IPDWorkup/GetIpdVisitInvestigationDetailByIPDVisitIdByIPDID/"+examvisitid +"/"+ipdid)
  }
  getIpdvisitDaigonsis(examvisitid,ipdid){
    return this.http.get<any>(this.newbaseUrl +"IPDWorkup/GetIpdVisitDiagnosisDetailByIPDVisitIdByIPDID/"+examvisitid +"/"+ipdid)
  }
  getIpdvisitExamination(examvisitid,ipdid){
    return this.http.get<any>(this.newbaseUrl +"IPDWorkup/GetIpdVisitExaminationDetailByIPDVisitIdByIPDID/"+examvisitid +"/"+ipdid)
  }
  getExaminationtype(){
    return this.http.get<any>(this.newbaseUrl +"Common/GetNameByType/IPDWorkUpExaminationType")
  }
 
  insertIPDDrExamination(data){
    return this.http.post<any>(this.newbaseUrl +"IPDWorkup/InsertIpdExaminationMaster",data);
  }
  GetNursingInstruction(ipdid){
    return this.http.get<any>(this.newbaseUrl +"IPDWorkup/GetNursingInstructionsByTranIdByIPDID/0/"+ipdid);
  }
  GetNursingChart(ipdid){
    return this.http.get<any>(this.newbaseUrl +"IPDWorkup/GetNursingChartByIPDID/"+ipdid);
  }
  GetNursingMedicine(ipdid){
    return this.http.get<any>(this.newbaseUrl +"IPDWorkup/GetNursingMedicineDetailByIPDID/"+ipdid);
  }
  GetCounselorPreOpMedicine(CounselorId){
    return this.http.get<any>(this.newbaseUrl +"Councelor/GetCounselorPreOpMedicineDetailByCounselorId/"+CounselorId);
  }
  InsertNursingInstructions(data){
    return this.http.post<any>(this.newbaseUrl +"IPDWorkup/InsertNursingInstructions",data);
  }
  InsertNursingMedicine(data){
    return this.http.post<any>(this.newbaseUrl +"IPDWorkup/InsertNursingMedicineDetail",data);
  }
  
  insertNursingChart(data){
    return this.http.post<any>(this.newbaseUrl +"IPDWorkup/InsertNursingChart",data);
  }
  
  GetWebReportPrint(data){
    return this.http.post<any>(this.newbaseUrl +"Configuration/GetWebReportPrintMasterByModuleByPrintOptionByPrintType",data);
  }
GetPermissionbyUser(userid,name){
    return this.http.get<any>(this.newbaseUrl +"UserMaster/GetOptionPermissionByUserIdByOption");
  }
  GetSurgeryOtRegisterByIPDId(IPDId){
    return this.http.get<any>(this.newbaseUrl +"IPDWorkup/GetSurgeryOtRegisterByIPDId/"+ IPDId );
  }
  GetOtRecordSurgeryByOTId(optid){
    return this.http.get<any>(this.newbaseUrl +"IPDWorkup/GetOtRecordSurgeryByOTId/"+ optid );
  }
  // counselor surgery detail 
  getSurgeryBycounselorId(counselorId) {
   // return this.http.get<any>(this.newbaseUrl + "Councelor/GetOpdCounselorSurgeryDetailByCounselorId/" + counselorId);
   return this.http.get<any>(this.newbaseUrl + "IPDWorkup/GetOpdCounselorSurgeryDetailByCounselorId/" + counselorId);
  }
  // counselor detail 
  getCounselordetailById(counselorId) {
    return this.http.get<any>(this.newbaseUrl + "Councelor/GetOpdCounselorExaminationByCounselorId/" + counselorId);
  }
  InsertOtRegister(data){
    return this.http.post<any>(this.newbaseUrl +"IPDWorkup/InsertOtRegister",data);
  }
 
  GetsurgeryStausId(){
    return this.http.get<any>(this.newbaseUrl +"Common/GetPopUpHelp/OTStatus");
  }
  GetSsCheckListName(){
    return this.http.get<any>(this.newbaseUrl +"IPDWorkUp/GetCheckListMasterNameByCheckListName/SSCHECKLISTMASTER").subscribe(
      data => this.success(data), err => this.failed(err)
    );
  }
  success(data){
this.sschecklistMaster = data;
  }
  failed(err){

  }
  GetSsCheckListBynameList(name:any){
    return this.http.get<any>(this.newbaseUrl +"IPDWorkUp/GetSsCheckListByCheckListName/" + name);
   // return this.http.get<any>(this.newbaseUrl +"IPDWorkUpMaster/GetSsCheckListByCheckListName/" + name);
  } 
   InsertSsCheckList(data){
    return this.http.post<any>(this.newbaseUrl +"IPDWorkup/InsertSsCheckList",data);
  } 
  GetSsCheckListByIPDId(id:any){
    return this.http.get<any>(this.newbaseUrl +"IPDWorkup/GetSsCheckListByIPDId/" + id);
  } 
  GetNursingChartByIPDID(id:any){
    return this.http.get<any>(this.newbaseUrl +"IPDWorkup/GetNursingChartByIPDID/" + id);
  } 
  InsertNursingChart(data){
    return this.http.post<any>(this.newbaseUrl +"IPDWorkup/InsertNursingChart",data);
  } 
  GetPostOpCheckListName(){
    return this.http.get<any>(this.newbaseUrl +"IPDWorkUp/GetCheckListMasterNameByCheckListName/POSTOPCHECKLISTMASTER");
  }
  GetPostOpCheckListByCheckListName(name:any){
   // return this.http.get<any>(this.newbaseUrl +"IPDWorkUpMaster/GetPostOpCheckListByCheckListName/" + name);
    return this.http.get<any>(this.newbaseUrl +"IPDWorkUp/GetPostOpCheckListByCheckListName/" + name);
  } 
  InsertPostOpCheckList(data){
    return this.http.post<any>(this.newbaseUrl +"IPDWorkup/InsertPostOpCheckList",data);
  } 
  GetPostOpCheckListByIPDId(id:any){
    return this.http.get<any>(this.newbaseUrl +"IPDWorkup/GetPostOpCheckListByIPDId/" + id);
  } 
  InsertPatientGeneralCheckupDetail(data){
    return this.http.post<any>(this.newbaseUrl +"IPDWorkUp/InsertPatientGeneralCheckupDetail",data);
  } 
  GetPatientGeneralCheckupDetailByRegId(id:any){
    return this.http.get<any>(this.newbaseUrl +"IPDWorkUp/GetPatientGeneralCheckupDetailByRegId/" + id);
  } 
  GetOtRegisterByRegId(Id){
    return this.http.get<any>(this.newbaseUrl +"IPDWorkup/GetOtRegisterByRegId/" + Id );
  } 
  GetOtRecordBySurgeryDateByRegIdByIPDIdByBranchId( date, regid, ipdId,  branchId){ 
    return this.http.get<any>(this.newbaseUrl +"IPDWorkUp/GetOtRecordBySurgeryDateByRegIdByIPDIdByBranchId/" + date + '/' + regid +'/'+  ipdId +'/'+  branchId);
  } 
  GetOtRecordByIPDAdmDateByRegIdByIPDId( date, regid, ipdId){
    return this.http.get<any>(this.newbaseUrl +"IPDWorkUp/GetOtRecordByIPDAdmDateByRegIdByIPDId/" + date +'/'+  regid + '/'+  ipdId );
  }  
  GetIOLBookingListByConsID(consId){
    return this.http.get<any>(this.newbaseUrl +"IPDWorkUp/GetIOLBookingListByConsID/" + consId );
  }
  GetOtIolPowerDetailByIPDId(ipdId){
    return this.http.get<any>(this.newbaseUrl +"IPDWorkup/GetOtIolPowerDetailByIPDId/" + ipdId );
  }
  NURSINGCHARGETYPEMASTER(){
    return this.http.get<any>(this.newbaseUrl +"Common/GetNameByType/NURSINGCHARGETYPEMASTER");
  } 
  GetNursingChargesByIPDId(ipdId){
    return this.http.get<any>(this.newbaseUrl +"IPDWorkup/GetNursingChargesByIPDId/" + ipdId);
  } 
  InsertNursingCharges(data){
    return this.http.post<any>(this.newbaseUrl +"IPDWorkup/InsertNursingCharges",data);
  } 
  
  GetPreOpTemplateMaster(transId){
    return this.http.get<any>(this.newbaseUrl +"CounselorMaster/GetPreOpTemplateMaster/" + transId);
  } 
  GetPreOpTemplatePrescriptionDetailByIdByTemplateId(templateId){
    return this.http.get<any>(this.newbaseUrl +"CounselorMaster/GetPreOpTemplatePrescriptionDetailByIdByTemplateId/0/" + templateId);
  } 
  GetPreOpTemplateInvestigationDetailByIdByTemplateId(templateId){
    return this.http.get<any>(this.newbaseUrl +"CounselorMaster/GetPreOpTemplateInvestigationDetailByIdByTemplateId/0/" + templateId);
  } 
  GetPreOpTemplateInstructionDetailByIdByTemplateId(templateId){
    return this.http.get<any>(this.newbaseUrl +"CounselorMaster/GetPreOpTemplateInstructionDetailByIdByTemplateId/0/" + templateId);
  } 
  InsertPreOpTemplateMaster(data){
    return this.http.post<any>(this.newbaseUrl +"CounselorMaster/InsertPreOpTemplateMaster",data);
  } 
  GetCounselorCheckListByCounselorId(CounselorId){
    return this.http.get<any>(this.newbaseUrl +"Councelor/GetCounselorCheckListByCounselorId/" + CounselorId);
  } 
  GetCounselorPreOpInvestigationByCounselorId(CounselorId){
    return this.http.get<any>(this.newbaseUrl +"Councelor/GetCounselorPreOpInvestigationByCounselorId/" + CounselorId);
  }  
  GetCounselorPreOpMedicineDetailByCounselorId(CounselorId){
    return this.http.get<any>(this.newbaseUrl +"Councelor/GetCounselorPreOpMedicineDetailByCounselorId/" + CounselorId);
  }  
  GetCounselorPreOpInstructionDetailByCounselorId(CounselorId){
    return this.http.get<any>(this.newbaseUrl +"Councelor/GetCounselorPreOpInstructionDetailByCounselorId/" + CounselorId);
  }
  InsertCounselorPreOpDetail(data){
    return this.http.post<any>(this.newbaseUrl +"Councelor/InsertCounselorPreOpDetail",data);
  } 
  GetPreOpAssesmentDetailByMaster(type,regis,ipdid){
    return this.http.get<any>(this.newbaseUrl +"IPDWorkup/GetPreOpAssesmentDetailByMasterTypeByRegIdByIPDId/" + type +'/'+ regis+'/'+ipdid);
  }
 GetPreOpAssesmentMasterByMasterType(type){
 // return this.http.get<any>(this.newbaseUrl +"IPDWorkupMaster/GetPreOpAssesmentMasterByMasterType/" + type);
 return this.http.get<any>(this.newbaseUrl +"IPDWorkup/GetPreOpAssesmentMasterByMasterType/" + type);
 
 }
 GetPreOpAssesmentRecordByRegIdByIPDId(regid ,ipdid){
  return this.http.get<any>(this.newbaseUrl +"IPDWorkup/GetPreOpAssesmentRecordByRegIdByIPDId/" + regid+'/'+ipdid);
 }
 
 InsertPreOpAssesmentRecord(data){
  return this.http.post<any>(this.newbaseUrl +"IPDWorkup/InsertPreOpAssesmentRecord",data);
}
GetAnestheticRecordByIPDId(ipdid){
  return this.http.get<any>(this.newbaseUrl +"IPDWorkup/GetAnestheticRecordByIPDId/"+ipdid);
 }
 GetAnestheticVitalDetailByIPDId(ipdid){
  return this.http.get<any>(this.newbaseUrl +"IPDWorkup/GetAnestheticVitalDetailByIPDId/"+ipdid);
 }
 InsertAnestheticRecord(data){
  return this.http.post<any>(this.newbaseUrl +"IPDWorkup/InsertAnestheticRecord",data);
 }
 GetPostAnesthesiaRecoveryScore(){
 // return this.http.get<any>(this.newbaseUrl +"IPDWorkupMaster/GetPostAnesthesiaRecoveryScoreMaster");
  return this.http.get<any>(this.newbaseUrl +"IPDWorkup/GetPostAnesthesiaRecoveryScoreMaster");
 }
 AnesthesiaRecoveryScoreDetailByIPDId(ipdid){
  return this.http.get<any>(this.newbaseUrl +"IPDWorkup/GetPostAnesthesiaRecoveryScoreDetailByIPDId/"+ipdid);
 }
 InsertPostAnesthesiaRecovery(data){
  return this.http.post<any>(this.newbaseUrl +"IPDWorkup/InsertPostAnesthesiaRecoveryScoreDetail",data);
 }
 InserttrackingData(branchid,today,fday){
  return this.http.get<any>(this.newbaseUrl +"IPDWorkUp/GetIpdTrackingByBranchIDByFromAdmDateByToAdmDate/"+branchid +'/'+today +'/'+fday);
 }

 get_saletype(){
  return this.http.get<any>(this.newbaseUrl+"Common/GetNameByType/ConsumptionSaleType")
 }

 getStoreData(branchId){
  return this.http.get<any>(this.newbaseUrl+"InventoryMaster/GetStoreItemConsumptionTemplateMasterByBranchId/"+ branchId)
 }

 getTemdatastore(templateId){
  return this.http.get<any>(this.newbaseUrl+"InventoryMaster/GetStoreItemConsumptionTemplateDetailByTemplateId/"+ templateId)
 }

getComlocationMst(branchId:any,depaId:any){
return this.http.get<any>(this.newbaseUrl+"InventoryMaster/GetConsumptionLocationMasterByBranchIdByDeptId/"+branchId +'/'+depaId);
}

get_partytpa() {
  return this.http.get<any>(this.newbaseUrl + "PartyMaster/GetPartyAll")
}


getDepartment(branchid:any){
  return this.http.get<any>(this.newbaseUrl + "DeptMaster/GetDept/"+ branchid)
}


// search item Api call 
getSearchitem(depaId:any,Itemcode:any){
  return this.http.get<any>(this.newbaseUrl + "GetStoresItemMasterByDeptIdByItemName/" + depaId + '/' + Itemcode)
}
// search barcode Api call 
getSearchBarcode(depaId:any,barcode:any){
  return this.http.get<any>(this.newbaseUrl + "InventoryMaster/GetStoresItemMasterByDeptIDByBarcode/" + depaId +'/'+ barcode )
}

// batchNO Api call
getBatchitem(depaId:any,itemId:any){
  return this.http.get<any>(this.newbaseUrl+"InventoryMaster/GetStoresItemMasterBatchDetailByDeptIdByItemId/" + depaId +'/'+ itemId )
}

// batch Api ...

getbatchdetails(depId:any,batchid:any){
  return this.http.get<any>(this.newbaseUrl+"InventoryMaster/GetStoresItemMasterBatchDetailByDeptIdByBatchId/" + depId +'/'+ batchid )
}


getviewConsumables(ipdId:any){
  return this.http.get<any>(this.newbaseUrl+"ipdworkup/GetStoresConsumeItemDetailByIPDId/"+ ipdId);
}


getStoresConsumeMaster(consumeId:any,regId:any,ipdId:any){
  return this.http.get<any>(this.newbaseUrl+"IPDWorkup/GetStoresConsumeMasterByConsumeIdByRegIdByIPDID/"+ consumeId +'/'+regId+'/'+ipdId)
}

getstoreConsumeDetails(consId:any){
return this.http.get<any>(this.newbaseUrl +"IPDWorkup/GetstoresConsumeItemDetailByConsumeId/"+consId);
}


getStoresConsumeMasterTracking(consId:any){
return this.http.get<any>(this.newbaseUrl +"IPDWorkup/GetStoresConsumeMasterTrackingByConsumeId/"+consId)
}

// IPDWorkup/StoresConsumeItemDetailByConsumeId/1
saveInsertStoresConsumeMaster(data){
  return this.http.post<any>(this.newbaseUrl +"IPDWorkup/InsertStoresConsumeMaster",data);
}

getCommanBatchno(deptId,itemId,batchId){
  return this.http.get<any>(this.newbaseUrl+"InventoryMaster/GetStoresItemMasterBatchDetailByDeptIdByItemIdByBatchId/"+deptId +'/'+ itemId +'/'+ batchId)
}


getSearchBulkApi(fromdata,todate,branchId,deptId){
  return this.http.get<any>(this.newbaseUrl+"IPDWorkup/GetStoresConsumeMasterByFromDateByToDateByBranchIdByDeptId/"+fromdata +'/'+ todate +'/'+ branchId +'/'+ deptId)
}


 printTimelineBill(regid) {

  let payload = {
    "WebReportPrintMaster": {
      "module": "Doctor",
     // "printOption": "Prescription",
     "printOption": "Medical Record",
      "printType": "WebNetramReport",
      "PRINTDATE": this.datePipe.transform(this.authservice.localDate, "dd-MM-yyyy"),
      "PrintTime": this.dashboardService.convertTime12Hour(new Date()),
      "Pk_RegId": regid,
      "BILLINGCOMPANYNAME": this.authservice.Loggeduser.billingcompanyname,
      "PRINTCONFIGURATIONARRAY":'N',
      "Pk_VisitId": 0,
      "Pk_ExamId": 0,
      "VISITDATE": this.datePipe.transform(new Date(), "dd-MM-yyyy"),
      "LINE1": this.dashboardService.branchmansterObj.line1,
      "LINE2": this.dashboardService.branchmansterObj.line2,
      "LINE3": this.dashboardService.branchmansterObj.line3,
      "LINE4": this.dashboardService.branchmansterObj.line4,
      "HOSPITALIMAGE": "../../../" + this.authservice.loginclientlogo,
      "COMPANYIMAGE": "../../../" + this.authservice.leftbottomlogosm,
      "CERTIFICATE1IMAGE": "../../../" + this.authservice.nabhlogo,
      "CERTIFICATE2COMPANYIMAGE": '',
      "PrintHeaderArray":'Y',
      "PatientRegistrationArray":'Y',
      "VisitMasterArray":'Y',
      'HistoryGeneralArray':'Y',
      'DoctorExaminationMasterArray':'Y',
      'AutoRefExaminationArray':'Y',
      'HistoryDiseaseArray':'Y',
      "CounselorExaminationArray":'Y',
      "HistorySurgicalArray":'Y',
      "HistoryFamilyArray":'Y',
      "HistoryDrugAllergyArray":'Y',
      "PresentingComplaintsArray":'Y',
      "AdvisedInvestigationsArray":'Y',
      "IntraocularPressureArray":'Y',
      "OptoExaminationArray":'Y',
      "OptoTestDetailArray":'Y',
      "OptoSlitLampExaminationArray":'Y',
      "CurrentMedicationDetailArray":'Y',
      "DoctorFindingArray":'Y',
      "DoctorInvestigationArray":'Y',
      "DoctorDiagnosisArray":'Y',
      "DoctorPrescriptionArray":'Y',
      "DoctorSurgeryArray":'Y',
    }
  }
  this.GetWebReportPrint(payload).subscribe((x: any) => {
  
    if (x.length > 0) {
      let printContents, popupWin;

      printContents = x[0].printTemplate;
      popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');

      popupWin.document.open();
      popupWin.document.write(`
<html>
 
<body onload="window.print()">${printContents}
</body>
</html>`
      );

      popupWin.document.close();
    } else {
      this.dashboardService.openSnackBar("Report Template Not Set", "OK");
    }
  }, err => {
   
    this.dashboardService.openSnackBar("Api Failed", "OK");
  })


}
getOtiolsaveData(ipdid){
  return this.http.get(this.dashboardService.newbaseUrl +"IPDWorkup/GetOtIolPowerDetailByIPDId/"+ipdid);
  
}
getDischargeLabInvestigation(ipdid){
  return this.http.get(this.dashboardService.newbaseUrl +"IPDWorkup/GetDischargeLabInvestigationDetailByIPDID/"+ipdid);
  
}
insertlabData(payloaddata){
  return this.http.post(this.dashboardService.newbaseUrl +"IPDWorkup/InsertDischargeLabInvestigationDetail",payloaddata);
}

insertOtiolData(formdata){
  return this.http.post(this.dashboardService.newbaseUrl +"IPDWorkup/InsertOtIolPowerDetail",formdata);
}
getRegisterNameData(type){
  return this.http.get(this.dashboardService.newbaseUrl +"Procedure/GetRegisterMasterByRegisterType/"+type);
}
GetOtRegisterMaster(type){
  return this.http.get(this.dashboardService.newbaseUrl +"IPDworkup/GetOtRegisterMasterByOTId/"+type);
}
GetNameByType(){
  return this.http.get(this.dashboardService.newbaseUrl +"Common/GetNameByType/RegisterType");
}
GetOtNotesByOTId(OTId){
  return this.http.get(this.dashboardService.newbaseUrl +"IPDWorkup/GetOtNotesByOTId/"+OTId);
}
InsertOtNotes(payload){
  return this.http.post(this.dashboardService.newbaseUrl +"IPDWorkup/InsertOtNotes",payload);
}
GetOtNotesMasterByGroupName(otname){
  return this.http.get(this.dashboardService.newbaseUrl +"IPDWorkup/GetOtNotesMasterByGroupName/"+otname);
 // return this.http.get(this.dashboardService.newbaseUrl +"IPDWorkupMaster/GetOtNotesMasterByGroupName/"+otname);
}
InsertOtNotesMaster(payload){
  return this.http.post(this.dashboardService.newbaseUrl +"IPDWorkupMaster/InsertOtNotesMaster",payload);
}

GetStauscheck(){
  return this.http.get(this.dashboardService.newbaseUrl +"Common/GetSurgeryStatusMaster/0");
}

GetOTList(payload){
  return this.http.post(this.dashboardService.newbaseUrl +"OPDManager/GetOTList",payload);
}

GetOTListPostponed(branchId:any,surgeryDate:any,mainSurgonId:any){
  return this.http.get(this.dashboardService.newbaseUrl +"OPDManager/GetOTListPostponed/"+ branchId +'/'+surgeryDate+'/'+mainSurgonId)
}


}    
